import AdminControlTypes from './AdminControlTypes'
export default AdminControlTypes
